<vw-toast-popup
  [isOpen]="isOpen"
  width="100%"
  borderRadius="20px"
  customClass="bg-white"
  (close)="onClose()"
>
  <div class="px-4 pb-2">
    <!-- Hero vert profond : le premium reste Vegiwise, le doré n'est qu'un accent -->
    <div
      class="-mx-4 mb-4 bg-gradient-to-br from-[#22634B] to-[#093935] px-5 py-6 text-white"
    >
      <span
        class="mb-3 inline-block rounded-full bg-gradient-to-r from-[#FFD37A] to-[#F79400] px-3 py-1 text-xs font-semibold text-[#3A2500]"
        >PREMIUM</span
      >
      <h2 class="text-2xl font-semibold">
        {{ "premium.paywall.title" | translate }}
      </h2>
      <p class="text-sm text-white/80">
        {{ "premium.paywall.subtitle" | translate }}
      </p>
    </div>

    <ul class="mb-5 flex flex-col gap-3">
      @for (key of ["lunar", "gdd", "willy", "garden"]; track key) {
        <li class="flex items-start gap-3">
          <span
            class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#DAF2E0]"
          >
            <svg
              class="h-3 w-3 text-[#317756]"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M5 13l4 4L19 7"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="text-sm text-[#062825]">
            {{ "premium.paywall.benefits." + key | translate }}
          </span>
        </li>
      }
    </ul>

    <!-- Plans. L'annuel est presélectionné : le badge « 2 mois offerts » n'a de
         sens que s'il est mis en avant. -->
    <div class="mb-4 flex gap-3">
      @for (plan of ["YEARLY", "MONTHLY"]; track plan) {
        <button
          type="button"
          (click)="selectPlan($any(plan))"
          class="flex-1 rounded-2xl border-2 px-3 py-3 text-left transition"
          [ngClass]="
            selectedPlan === plan
              ? 'border-[#317756] bg-[#F2FAF5]'
              : 'border-[#E3E8E5] bg-white'
          "
        >
          <span class="block text-base font-semibold text-[#062825]">
            {{
              (plan === "YEARLY"
                ? "premium.paywall.yearly"
                : "premium.paywall.monthly"
              ) | translate: { price: pricing.label(plan) }
            }}
          </span>
          @if (plan === "YEARLY") {
            <!-- Badge et equivalent mensuel CALCULES depuis les prix du
                 fournisseur : ecrits en dur, ils deviendraient faux des qu'un
                 palier change ou que le pays differe. Absents s'ils ne sont pas
                 calculables. -->
            @if (pricing.monthsFree(); as monthsFree) {
              <span
                class="mt-1 inline-block rounded-full bg-gradient-to-r from-[#FFD37A] to-[#F79400] px-2 py-0.5 text-[11px] font-semibold text-[#3A2500]"
              >
                {{
                  "premium.paywall.yearly-badge"
                    | translate: { count: monthsFree }
                }}
              </span>
            }
            @if (pricing.monthlyEquivalent(); as monthlyEquivalent) {
              <span class="mt-1 block text-xs text-[#6E7B75]">
                {{
                  "premium.paywall.yearly-monthly-equivalent"
                    | translate: { price: monthlyEquivalent }
                }}
              </span>
            }
          }
        </button>
      }
    </div>

    @if (isGuest) {
      <p class="mb-3 rounded-xl bg-[#FFF6E4] px-3 py-2 text-sm text-[#7A4B00]">
        {{ "premium.paywall.account-required" | translate }}
      </p>
    } @else if (activating) {
      <p class="mb-3 text-center text-sm text-[#6E7B75]">
        {{
          (activationSlow
            ? "premium.paywall.activation-slow"
            : "premium.paywall.activating"
          ) | translate
        }}
      </p>
    } @else {
      <!-- Essai d'abord tant qu'il n'a pas ete consomme : c'est le levier de
         conversion le plus efficace, et il n'exige aucune carte. -->
      @if (canStartTrial) {
        <vw-button
          look="primary"
          [label]="'premium.paywall.cta-trial' | translate"
          [loading]="loading"
          customClass="w-full"
          (click)="startTrial()"
        />
        <p class="mt-1 text-center text-xs text-[#6E7B75]">
          {{ "premium.paywall.trial-no-card" | translate }}
        </p>
      } @else {
        <!-- Un changement de formule ne prend pas effet tout de suite : la
             periode deja reglee court jusqu'a son terme. Le taire laisserait
             croire a un double prelevement. -->
        @if (isPlanChange && currentPeriodEndLabel) {
          <p
            class="mb-2 rounded-xl bg-[#F2FAF5] px-3 py-2 text-xs leading-relaxed text-[#1C5C41]"
          >
            {{
              "premium.paywall.plan-change-from"
                | translate: { date: currentPeriodEndLabel }
            }}
          </p>
        }
        <vw-button
          look="primary"
          [label]="
            (isCurrentPlan
              ? 'premium.paywall.cta-current'
              : 'premium.paywall.cta-subscribe'
            ) | translate
          "
          [loading]="loading"
          [disabled]="isCurrentPlan"
          customClass="w-full"
          (click)="subscribe()"
        />
      }

      <!-- Achat en attente d'un accord (« Demander a acheter », controle
           parental) : l'acces n'est pas immediat, et le taire laisserait croire
           a un echec. -->
      @if (purchasePending) {
        <p
          class="mt-2 rounded-xl bg-[#FFF6E4] px-3 py-2 text-xs leading-relaxed text-[#7A4B00]"
        >
          {{ "premium.store.pending" | translate }}
        </p>
      }

      <!-- « Restaurer mes achats » : EXIGE par Apple pour toute app vendant un
           abonnement. Sans lui, quelqu'un qui reinstalle l'app ne retrouve pas
           ce qu'il a paye — et c'est un motif de refus. Sans objet sur le web,
           ou l'abonnement suit le compte et non l'appareil. -->
      @if (isStore) {
        <button
          type="button"
          class="mt-3 w-full text-center text-xs font-medium text-[#1C5C41] underline disabled:opacity-50"
          [disabled]="restoring"
          (click)="restorePurchases()"
        >
          {{ "premium.store.restore" | translate }}
        </button>
        @if (restored === false) {
          <p class="mt-1 text-center text-xs text-[#6E7B75]">
            {{ "premium.store.restore-none" | translate }}
          </p>
        }
      }
    }

    @if (error) {
      <!-- Un tunnel de paiement qui n'a pas pu s'ouvrir n'est pas la faute de
           l'utilisateur : on dit ce qui s'est passé et on laisse réessayer,
           plutôt qu'un « erreur » sec qui laisse croire à un refus. -->
      <p class="mt-2 text-center text-sm text-[#A9773A]">
        {{ "premium.paywall.checkout-failed" | translate }}
      </p>
    }

    <!-- Visible AVANT tout achat : argument de conversion, pas mention legale -->
    <p class="mt-4 text-center text-sm font-medium text-[#317756]">
      {{ "premium.paywall.cancellable" | translate }}
    </p>
    <p class="mt-1 text-center text-xs text-[#9BA6A1]">
      {{ "premium.paywall.no-commitment" | translate }}
    </p>
  </div>
</vw-toast-popup>
